import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html'
})
export class AuthComponent implements AfterViewInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngAfterViewInit() {
    const url = this.router.routerState.snapshot.url;
    setTimeout(() => {
      if (decodeURI(url).indexOf('/sign-out') != -1) {
        this.authService.signOut();
      }
    });
  }
}
